if (!customElements.get('marquee-motion')) {
  customElements.define('marquee-motion', class extends HTMLElement {
    connectedCallback() {
      this.visible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateMotion = () => {
        const running = this.visible && !document.hidden && !this.reducedMotion.matches;
        if (running === this.hasAttribute('data-running')) return;
        this.toggleAttribute('data-running', running);
        this.dispatchEvent(new CustomEvent('marquee:visibility', { detail: { running } }));
      };

      document.addEventListener('visibilitychange', this.updateMotion);
      this.reducedMotion.addEventListener('change', this.updateMotion);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting);
          this.updateMotion();
        });
        this.observer.observe(this);
      } else {
        this.visible = true;
        this.updateMotion();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.updateMotion);
      this.reducedMotion.removeEventListener('change', this.updateMotion);
      this.visible = false;
      this.updateMotion();
    }
  });
}
